import { ErrorType, Result, TransactionSettingsHeader } from "@bridgesplit/utils";
import { AppCookie, getAvatarFromString, getBearerToken } from "@bridgesplit/react";
import { AbfTransactionHeaders } from "@bridgesplit/abf-sdk";

import { AUTH0_COOKIES_PREFIX, ABF_GROUP_COOKIE_PREFIX, TRANSACTION_SETTINGS_COOKIE_PREFIX } from "../constants";
import { AuthSliceState } from "../reducers";

export function getTransactionHeadersFromCookies(state: { authSlice: AuthSliceState }): Result<AbfTransactionHeaders> {
    const bearerToken = getBearerToken(AUTH0_COOKIES_PREFIX);
    const groupIdentifier = getBearerToken(ABF_GROUP_COOKIE_PREFIX);
    const userWallet = state.authSlice.stateWalletAddress || undefined;
    const txnSettings = parseTransactionSettings(AppCookie.get(TRANSACTION_SETTINGS_COOKIE_PREFIX));

    if (!bearerToken && !userWallet) {
        return Result.errFromMessage("No authentication provided", { errorType: ErrorType.AuthError });
    }

    return Result.ok({ groupIdentifier, bearerToken, userWallet, txnSettings });
}

export function parseTransactionSettings(settings: string | undefined): TransactionSettingsHeader | undefined {
    if (!settings) return undefined;
    try {
        return JSON.parse(settings) as TransactionSettingsHeader;
    } catch {
        return undefined;
    }
}

export function getAvatarFromName(name: string | undefined) {
    if (!name) return undefined;
    const names = name?.split(" ");
    const initials = names.map((n) => n.replace(/[0-9]/g, "")?.[0]);
    return getAvatarFromString(initials.join(""));
}
